import { render, staticRenderFns } from "./fccPublicarSolicitacoes.vue?vue&type=template&id=61af0b28"
import script from "./fccPublicarSolicitacoes.vue?vue&type=script&lang=js"
export * from "./fccPublicarSolicitacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports